//import angular from 'angular';
const moduleName = 'app.controllers';
export default moduleName;

angular.module(moduleName, []);
